import { setProps } from '../props';
import fetchItemDescriptions from "../../../Core/Services/fetchItemDescriptions";

export default (props) => (dispatch) => {

  setProps(props);
  dispatch(fetchItemDescriptions());
  
}